import React from 'react';
import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { PdpSharedSourcingModalLoaderWrapper } from '../PdpSharedModals/PdpSharedSourcingModal/PdpSharedSourcingModalLoaderWrapper';
// styles
import styles from './PdpSharedButtons.scss';

export class PdpSharedRequestSourcingButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    render() {
        return (
            <React.Fragment>
                <Button
                    className={`${styles.button} ${styles.fullWidth}`}
                    dataTn="item-actions-request-sourcing"
                    onClick={this.openModal}
                >
                    <FormattedMessage
                        id="PdpSharedRequestSourcingButton.requestSourcingCta"
                        defaultMessage="Request Sourcing Help"
                    />
                </Button>
                <PdpSharedSourcingModalLoaderWrapper
                    environment={this.props.environment}
                    itemId={this.props.itemId}
                    isOpen={this.state.isModalOpen}
                    onClose={this.closeModal}
                />
            </React.Fragment>
        );
    }
}

PdpSharedRequestSourcingButton.propTypes = {
    environment: PropTypes.object.isRequired,
    itemId: PropTypes.string.isRequired,
};
